/**
 * Synchronous auth token store.
 * AuthContext writes here on every session change via onAuthStateChange.
 * The axios interceptor reads from here — no async getSession() race.
 */

let _token: string | null = null

export function setAuthToken(token: string | null): void {
  _token = token
}

export function getAuthToken(): string | null {
  return _token
}
